"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAhoyAnalyticsTrackerConfig = void 0;
var getAhoyAnalyticsTrackerConfig = function (beaconUrl) { return ({
    urlPrefix: beaconUrl,
    platform: "Web",
    useBeacon: true,
    trackVisits: true,
    cookies: true,
    cookieDomain: null,
    headers: {
        "Content-Type": "application/json",
    }
}); };
exports.getAhoyAnalyticsTrackerConfig = getAhoyAnalyticsTrackerConfig;
